import React from "react"
import {AppRetailerBlockContainer} from "@components";


export default function sitesNameColumn() {
    return {
        name: "sitesName", label: "Sites",
        options: {
            sort: false,
            customBodyRowRenderLite: value => <AppRetailerBlockContainer rows={value} />
        }
    }
}